/* */
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getUserServlet } = actions;

export default ({ shouldTrigger = true } = {}) => {
  //! State
  const authReducer = useSelector((state) => state.authReducer);
  const { isLogin } = authReducer;
  const dispatch = useDispatch();

  //! Function
  const refetch = useCallback(() => {
    dispatch(getUserServlet({ refetch: true }));
  }, [dispatch]);

  useEffect(() => {
    if (isLogin && shouldTrigger) {
      dispatch(getUserServlet({}));
    }
  }, [shouldTrigger, isLogin]);

  return [refetch];
};
